export function parseJwt(token) {
  try {
    const base64Url = token.split('.')[1]; // payload만 가져오기
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const payload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join('')
    );
    return JSON.parse(payload);
  } catch (err) {
    console.error('JWT 파싱 실패:', err);
    return null;
  }
}

export function isTokenExpired(token) {
  try {
    const payload = parseJwt(token);
    if (!payload?.exp) return true;

    const currentTime = Math.floor(Date.now() / 1000); // 초 단위 현재 시간
    return currentTime > payload.exp;
  } catch {
    return true;
  }
}